import { render, staticRenderFns } from "./rombel.vue?vue&type=template&id=a7409a7e&"
import script from "./rombel.vue?vue&type=script&lang=js&"
export * from "./rombel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports